import PostsContainer from 'modules/posts/containers/PostsContainer';

const PostsView = props => <PostsContainer {...props} />;

export default PostsView;
